import React from 'react'
import { EntryPage } from '@emerald-works-nova/auth'
import { Grid, Button } from '@mui/material'
import { useNavigate } from 'react-router'
import { routes } from '../../../routes'
import { Ghost } from '../../../components/entry-decoration'
import { useStyles } from '../style.js'

const ResetPasswordErrorPage = () => {
  const navigate = useNavigate()
  const classes = useStyles()

  return (
    <Grid
      container
      direction='column'
      wrap='nowrap'
    >
      <Grid item style={{ minHeight: 85 }} />
      <Grid item>
        <EntryPage
          title='Sorry, the link has expired'
          showMtLogo
          subtitle='Please, request the password reset again.'
          content={<Button variant='contained' color='primary' className={classes.btn} onclick={() => navigate(routes.login.path)}>Back to Sign In</Button>}
          application={process.env.REACT_APP_APPLICATION_NAME}
          decoration={<Ghost />}
        />
      </Grid>
    </Grid>
  )
}

export default ResetPasswordErrorPage
